import state from "@/store/modules/sales-historic/state";
import actions from "@/store/modules/sales-historic/actions";
import mutations from "@/store/modules/sales-historic/mutations";
import getters from "@/store/modules/sales-historic/getters";

export default {
    state,
    actions,
    mutations,
    getters
}